module.exports = __webpack_public_path__ + "img/Noodles Icon - white.dd5fe71c.svg";